import React, { Fragment } from "react";
import { Button, Row, Modal, Form } from "react-bootstrap";
import "../../App.css";
import UploadAGgrid from "../../UploadAGgrid";
import {
  UploadSuccessMsg,
  UploadErrorMsg,
  CustomModal,
  PrimaryButton,
  BulletTag,
  CustomRadioButton,
  ProgressBar,
} from "../../components";
import DownloadTemplate from "./DownloadTemplate";
import { ApiService } from "../../utils/ApiService";
import { API_URL, ADMIN_TYPE } from "../../utils/Constants";
import { ActivityStatus } from "./ActivityStatus";
import { Typography } from "@mui/material";
import {
  API_AUTH_TOKEN,
  API_CONTEXT_TYPE,
  API_METHOD_GET,
  API_METHOD_POST,
  STUDENT_DATA_ALERTMSG,
  STUDENT_DATA_CONSTANTS,
  STUDENT_DATA_FILE_MAX_SIZE,
} from "../../config/constants";
import { DownArrowLogo, UpArrowLogo, SideBarAddLogo } from "../../assets/icons";
import { TEXT_ALIGN_LEFT } from "../../config/styles";
import { colors } from "../../config/colors";

const STEP_STATE = { active: 0, disabled: 1, completed: 3 };

class StudentUpload extends React.Component {
  constructor(props) {
    super(props);
    this.alertMsg = STUDENT_DATA_ALERTMSG;
    this.authCode = localStorage.getItem("bearer");
    this.updatePercentCount = 0;
    setTimeout(() => this.onCommitProgressPercentage(), 1000);
    this.state = {
      newLogin: true,
      isNewLoginDelete: true,
      isSalesAdmin: false,
      isUpdateRadioActive: true,
      showValidationDownloadBtn: false,
      showAlertModal: false,
      alertModalMsg: "",
      processValidationFileName: "",
      uplodedFileName: "",
      fieldVal: "",
      file1: "",
      uploadFailure1: false,
      showUploadGrid: false,
      uploadDataList: [],
      spinner: false,
      commitList: false,
      exsistingList: [],
      fileSizeData: "",
      commitShow: false,
      currentStatus: null,
      showIsProgressMsg: false,
      step1State: STEP_STATE.active,
      isUploadBtnDisable: true,
      isUploadBtnLoading: false,
      step1Toggle: true,
      step2State: STEP_STATE.disabled,
      isValidateBtnDisable: false,
      isValidateBtnLoading: false,
      step2Toggle: true,
      step3State: STEP_STATE.disabled,
      isSubmitBtnLoading: false,
      step3Toggle: true,
      progressPercent: 0,
      progressCompleteText: "",
      progressFileDownloadUrl: "",
      validateProgressPercent: 0,
      nullErrorMsg: "",
      showNullError: "",
      merchantIdGlobal: "",
    };
  }

  resetStates = () => {
    setTimeout(() => {
      this.setState({
        showIsProgressMsg: false,
        showValidationDownloadBtn: false,
        showAlertModal: false,
        alertModalMsg: "",
        processValidationFileName: "",
        uplodedFileName: "",
        fieldVal: "",
        file1: "",
        uploadFailure1: false,
        showUploadGrid: false,
        uploadDataList: [],
        spinner: false,
        commitList: false,
        exsistingList: [],
        fileSizeData: "",
        commitShow: false,
        step1State: STEP_STATE.active,
        isUploadBtnDisable: true,
        isUploadBtnLoading: false,
        step1Toggle: true,
        step2State: STEP_STATE.disabled,
        isValidateBtnDisable: false,
        isValidateBtnLoading: false,
        step2Toggle: true,
        step3State: STEP_STATE.disabled,
        isSubmitBtnLoading: false,
        step3Toggle: true,
        progressPercent: 0,
        progressCompleteText: "",
        progressFileDownloadUrl: "",
        validateProgressPercent: 0,
        merchantIdGlobal: "",
      });
    }, 1000);
  };

  componentDidMount() {
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (
      roleData === ADMIN_TYPE.SUPERADMIN ||
      roleData === ADMIN_TYPE.SALESADMIN
    ) {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData === ADMIN_TYPE.SCHOOLADMIN) {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }
    this.setState({
      merchantIdGlobal: merchantIdGlobal,
    });
  }

  componentWillUnmount() {
    this.onAbortUploading();
  }

  get merchantID() {
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (
      roleData === ADMIN_TYPE.SUPERADMIN ||
      roleData === ADMIN_TYPE.SALESADMIN
    ) {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData === ADMIN_TYPE.SCHOOLADMIN) {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }
    return merchantIdGlobal;
  }

  abortAction = async () => {
    let merchantIdGlobal = this.merchantID;
    try {
      const url =
        API_URL.ABORT_UPDATE_PROGRESS + "?schoolId=" + merchantIdGlobal;
      const resp = await ApiService.postRequest(url);
      if (resp.status.code === "Y" && resp.body && resp.body.length > 0) {
        this.setState((prevState) => ({
          ...prevState,
          step3State: STEP_STATE.completed,
          isSubmitBtnLoading: false,
          showAlertModal: true,
          alertModalMsg: this.alertMsg.abortSuccessMessage,
        }));
        return;
      }
    } catch (err) {
      console.error("Error aborting upload:", err);
    }
    this.setState((prevState) => ({
      ...prevState,
      step3State: STEP_STATE.completed,
      isSubmitBtnLoading: false,
      showAlertModal: true,
      alertModalMsg: this.alertMsg.abortFailureMessage,
    }));
  };

  onAbortUploading = async () => {
    let merchantIdGlobal = this.merchantID;
    if (!this.state.isSubmitBtnLoading) {
      const typeURL = API_URL.ABORT_UPLOADING;
      const url = typeURL + "?schoolId=" + merchantIdGlobal;
      fetch(url, {
        method: API_METHOD_POST,
        headers: {
          "Content-Type": API_CONTEXT_TYPE,
          Authorization: this.authCode,
          "X-Auth-Token": API_AUTH_TOKEN,
          Accept: API_CONTEXT_TYPE,
        },
      }).catch((err) => {
        console.error("Error aborting upload:", err);
      });
    }
  };

  onCommitProgressPercentage = async () => {
    let merchantIdGlobal = this.merchantID;
    try {
      const url =
        API_URL.COMMIT_PROGRESS_PERCENTAGE + "?schoolId=" + merchantIdGlobal;
      const resp = await ApiService.postRequestWithLoginToken(url);
      const { newLogin, isNewLoginDelete } = this.state;
      if (
        resp?.status?.code === "Y" &&
        resp.body &&
        typeof resp.body === "object"
      ) {
        if (
          (newLogin || isNewLoginDelete) &&
          resp.body.percentageCompleted !== 0 &&
          (resp.body.completionStatus ===
            STUDENT_DATA_CONSTANTS.FILESTATUS_PROGRESS ||
            resp.body.completionStatus ===
            STUDENT_DATA_CONSTANTS.FILESTATUS_RETRY)
        ) {
          this.setState({
            showIsProgressMsg: true,
            step1State: STEP_STATE.disabled,
            step1Toggle: false,
            step3State: STEP_STATE.active,
            newLogin: false,
            isNewLoginDelete: false,
          });
        }
        if (
          (newLogin || isNewLoginDelete) &&
          resp.body.percentageCompleted === 0 &&
          resp.body.completionStatus ===
          STUDENT_DATA_CONSTANTS.FILESTATUS_PROGRESS
        ) {
          this.setState(
            {
              newLogin: false,
              isNewLoginDelete: false,
              showIsProgressMsg: true,
              step1State: STEP_STATE.completed,
              step1Toggle: false,
              step2State: STEP_STATE.completed,
              step2Toggle: false,
              step3State: STEP_STATE.active,
              step3Toggle: true,
              isSubmitBtnLoading: true,
            },

            () => {
              setTimeout(() => this.onCommitProgressPercentage(), 1000);
            }
          );
        } else if (
          (newLogin || isNewLoginDelete) &&
          (resp.body.completionStatus ===
            STUDENT_DATA_CONSTANTS.FILESTATUS_COMPLETED ||
            resp.body.completionStatus ===
            STUDENT_DATA_CONSTANTS.FILESTATUS_ABORTED)
        ) {
          this.setState({ newLogin: false, isNewLoginDelete: false });
        } else if (
          resp.body.completionStatus ===
          STUDENT_DATA_CONSTANTS.FILESTATUS_COMPLETED
        ) {
          this.setState({
            currentStatus: resp.body,
            progressCompleteText: resp.body.message || "",
            newLogin: false,
            isNewLoginDelete: false,
            step3State: STEP_STATE.completed,
            isSubmitBtnLoading: false,
            showAlertModal: true,
            alertModalMsg: this.alertMsg.commitSuccessMsg,
            step1State: STEP_STATE.active,
          });
        } else if (
          resp.body.completionStatus ===
          STUDENT_DATA_CONSTANTS.FILESTATUS_ABORTED
        ) {
          this.setState({
            currentStatus: resp.body,
            progressCompleteText: resp.body.message || "",
            newLogin: false,
            isNewLoginDelete: false,
            isSubmitBtnLoading: false,
            step3State: STEP_STATE.completed,
            showIsProgressMsg: false,
            step1State: STEP_STATE.active,
            step1Toggle: true,
            showAlertModal: true,
            alertModalMsg: this.alertMsg.abortSuccessMessage,
          });
        } else {
          this.setState(
            {
              newLogin: false,
              currentStatus: resp.body,
              step1State: STEP_STATE.completed,
              step1Toggle: false,
              step2State: STEP_STATE.completed,
              step2Toggle: false,
              step3State: STEP_STATE.active,
              isSubmitBtnLoading: true,
            },
            () => {
              setTimeout(() => this.onCommitProgressPercentage(), 1000);
            }
          );
        }
      } else if (!resp.body && this.state.isSubmitBtnLoading) {
        setTimeout(() => this.onCommitProgressPercentage(), 1000);
      } else if (resp?.status?.code === "N") {
        if (this.updatePercentCount < 3) {
          this.updatePercentCount++;
          setTimeout(() => this.onCommitProgressPercentage(), 2000);
        }
        this.setState({ newLogin: false, isNewLoginDelete: false });
      }
    } catch (err) {
      console.error("Error fetching commit progress:", err);
    }
  };

  onHideAlertModal = () => {
    if (this.state.step3State === STEP_STATE.completed) this.resetStates();
    this.setState({ showAlertModal: false, alertModalMsg: "" });
  };

  commitListClose = () => {
    this.setState({ commitList: false, isSubmitBtnLoading: false });
  };

  handleUploadCommit = (e) => {
    let authCode = localStorage.getItem("bearer");
    this.setState({
      isSubmitBtnLoading: true,
      currentStatus: {
        completionStatus: STUDENT_DATA_CONSTANTS.FILESTATUS_PREPARE,
      },
    });
    if (this.state.isUpdateRadioActive) {
      this.commitLater([]);
      return;
    }
    const existUrl = this.state.isUpdateRadioActive
      ? API_URL.SUBMIT_UPDATE
      : API_URL.SUBMIT_DELETE;
    let url = existUrl + this.state.merchantIdGlobal;
    fetch(url, {
      method: API_METHOD_GET,
      headers: {
        "Content-Type": API_CONTEXT_TYPE,
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.json();
      })
      .then((response) => {
        const commitDetails = response.body;
        this.commitLater(commitDetails);
      })
      .catch((error) => {
        console.error("Error fetching commit details:", error);
      });
  };

  commitListOk = () => {
    let commitOkList = this.state.exsistingList;
    this.commitLater(commitOkList);
    this.setState({ commitList: false });
  };

  commitLater(commitData) {
    let data2 = {
      existingStudentIds: commitData,
      schoolId: this.state.merchantIdGlobal,
    };
    let authCode = localStorage.getItem("bearer");
    setTimeout(() => {
      this.onCommitProgressPercentage();
    }, 2000);
    const url = this.state.isUpdateRadioActive
      ? API_URL.COMMIT_UPDATE
      : API_URL.COMMIT_DELETE;
    fetch(url, {
      method: API_METHOD_POST,
      body: JSON.stringify(data2),
      headers: {
        "Content-Type": API_CONTEXT_TYPE,
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
      },
    }).then((response) => {
      const auth = response.headers.get("Authorization");
      if (auth) localStorage.setItem("bearer", auth);
      return response.json();
    });
  }

  onChange = (e) => {
    let sizeOfFile = e;
    if (!sizeOfFile[0]) return;
    let fileName = sizeOfFile[0].name;
    if (fileName.length > 25) {
      fileName = fileName.slice(0, 22);
      fileName = fileName + "...";
    }
    this.setState({
      uplodedFileName: fileName,
      fileSizeData: sizeOfFile[0].size,
    });
    if (sizeOfFile[0].size > STUDENT_DATA_FILE_MAX_SIZE) {
      this.setState({
        showAlertModal: true,
        alertModalMsg: this.alertMsg.fileSizeMsg,
      });
    }
  };

  fileUpload = () => {
    if (
      this.state.fileSizeData <= STUDENT_DATA_FILE_MAX_SIZE &&
      this.state.uplodedFileName != ""
    ) {
      this.setState({ isUploadBtnLoading: true });
      const inputFiles = document.querySelectorAll('input[type="file"]');
      const formData = new FormData();

      for (const file of inputFiles) {
        formData.append("file", file.files[0]);
        formData.append("schoolId", this.state.merchantIdGlobal);
      }
      let authCode = localStorage.getItem("bearer");
      const uploadUrl = this.state.isUpdateRadioActive
        ? API_URL.UPLOAD_UPDATE_TEMPLATE
        : API_URL.UPLOAD_DELETE_TEMPLATE;
      fetch(uploadUrl, {
        method: API_METHOD_POST,
        body: formData,
        headers: {
          Authorization: authCode,
          "X-Auth-Token": API_AUTH_TOKEN,
          Accept: API_CONTEXT_TYPE,
        },
      })
        .then((response) => {
          const auth = response.headers.get("Authorization");
          if (auth) localStorage.setItem("bearer", auth);
          return response.json();
        })
        .then((response) => {
          if (
            response?.error?.status_code === 401 ||
            response.status === "403" ||
            response?.status?.internalMessage?.includes("403")
          ) {
            this.setState({
              showAlertModal: true,
              alertModalMsg: this.alertMsg.sessionExpiry,
            });
            return;
          }
          this.setState({ isUploadBtnLoading: false, fieldVal: response.body });
          if (response.status.code == "Y") {
            this.setState({
              step1State: STEP_STATE.completed,
              isUploadBtnDisable: true,
            });
            setTimeout(() => {
              this.setState({
                step1Toggle: false,
                step2State: STEP_STATE.active,
              });
            }, 2000);
          } else if (response.status.code == "N") {
            const errMsg = response.status.message
              ? response.status.message
              : STUDENT_DATA_CONSTANTS.ERROR_PROCESS_FILE;

            this.setState({ showAlertModal: true, alertModalMsg: errMsg });
          }
        });
    } else if (this.state.fileSizeData >= STUDENT_DATA_FILE_MAX_SIZE) {
      this.setState({
        showAlertModal: true,
        alertModalMsg: this.alertMsg.fileSizeMsg,
      });
    } else if (this.state.fileSizeData === "") {
      this.setState({
        showAlertModal: true,
        alertModalMsg: this.alertMsg.noFileErr,
      });
    }
  };

  validateFile = async () => {
    if (this.state.isValidateBtnLoading) return;
    let merchantIdGlobal = this.merchantID;
    let data = {
      schoolId: merchantIdGlobal,
      fileId: this.state.fieldVal,
    };
    this.setState({ validateProgressPercent: 0, isValidateBtnLoading: true });
    const url = this.state.isUpdateRadioActive
      ? API_URL.VALIDATE_UPDATE_FILE
      : API_URL.VALIDATE_DELETE_FILE;
    if (this.state.isUpdateRadioActive) {
      const resp = await ApiService.postRequest(url, data);
      if (resp.status.code === "Y") this.onValidatePercentage();
      else if (
        (resp.status.code === "N" &&
          resp.status.errorCode === "PROCESS_NO_DATA") ||
        resp.status.errorCode === "MAX RECORD EXCEED"
      ) {
        this.setState({
          nullErrorMsg: resp.status.message,
          showNullError: true,
          isValidateBtnLoading: false,
        });
      }
    } else {
      this.onValidatePercentage();
      const resp = await ApiService.postRequest(url, data);
      if (resp.status.code === "Y") {
        this.handleGetListSec();
        this.setState({
          validateProgressPercent: 0,
          isValidateBtnDisable: true,
          commitShow: true,
          isValidateBtnLoading: false,
        });
      } else if (
        (resp.status.code === "N" &&
          resp.status.errorCode === "PROCESS_NO_DATA") ||
        resp.status.errorCode === "MAX RECORD EXCEED"
      ) {
        this.setState({
          nullErrorMsg: resp.status.message,
          showNullError: true,
          isValidateBtnLoading: false,
        });
      } else {
        this.setState({
          validateProgressPercent: 0,
          isValidateBtnLoading: false,
          showValidationDownloadBtn: true,
          processValidationFileName: resp.body,
          uploadFailure1: true,
        });
      }
    }
  };

  onValidatePercentage = async () => {
    let merchantIdGlobal = this.merchantID;
    const baseUrl = this.state.isUpdateRadioActive
      ? API_URL.UPDATE_VALIDATE_PERCENTAGE
      : API_URL.DELETE_VALIDATE_PERCENTAGE;
    const url = baseUrl + "?schoolId=" + merchantIdGlobal;
    const resp = await ApiService.postRequest(url);
    if (this.state.isUpdateRadioActive) {
      if (resp.body.fileStatus === "PROCESSFAILED") {
        this.setState({
          validateProgressPercent: 0,
          isValidateBtnLoading: false,
          showValidationDownloadBtn: true,
          processValidationFileName: resp.body.filename,
          uploadFailure1: true,
        });
        return;
      }
      if (resp.body.fileValidationPercentage === 100) {
        setTimeout(() => this.onGetProcessStatus(), 3000);
      } else {
        setTimeout(() => this.onValidatePercentage(), 3000);
      }
      this.setState({
        validateProgressPercent: resp.body.fileValidationPercentage,
      });
    } else {
      if (this.state.isValidateBtnLoading) {
        setTimeout(() => this.onValidatePercentage(), 3000);
      }
      this.setState({ validateProgressPercent: resp.body });
    }
  };

  onGetProcessStatus = async () => {
    let merchantIdGlobal = this.merchantID;
    const baseUrl = this.state.isUpdateRadioActive
      ? API_URL.GET_PROCESS_STATUS
      : API_URL.GET_DELETE_PROCESS_STATUS;
    const url = baseUrl + "?schoolId=" + merchantIdGlobal;
    const resp = await ApiService.postRequest(url);
    if (resp.status.code == "Y" && resp.body.fileStatus === "FILEPROCESSED") {
      this.handleGetListSec();
      this.setState({
        validateProgressPercent: 0,
        isValidateBtnDisable: true,
        commitShow: true,
        isValidateBtnLoading: false,
      });
    } else if (
      resp.status.code == "Y" &&
      resp.body.fileStatus === "PROCESSFAILED"
    ) {
      this.setState({
        validateProgressPercent: 0,
        isValidateBtnLoading: false,
        showValidationDownloadBtn: true,
        processValidationFileName: resp.body.filename,
        uploadFailure1: true,
      });
    }
  };

  handleGetListSec() {
    let merchantIdGlobal = this.merchantID;
    let authCode = localStorage.getItem("bearer");
    const data = { schoolId: merchantIdGlobal };
    const url = this.state.isUpdateRadioActive
      ? API_URL.GET_LIST_SEC
      : API_URL.DELETE_GET_LIST_SEC;
    fetch(url, {
      method: API_METHOD_POST,
      body: JSON.stringify(data),
      headers: {
        "Content-Type": API_CONTEXT_TYPE,
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.json();
      })
      .then((response) => {
        if (
          response?.error?.status_code === 401 ||
          response.status === "403" ||
          response?.status?.internalMessage?.includes("403")
        ) {
          this.setState({
            showAlertModal: true,
            alertModalMsg: this.alertMsg.sessionExpiry,
          });
          return;
        }
        if (response.status.code == "Y") {
          this.setState({ uploadDataList: response.body });
          setTimeout(this.setState({ showUploadGrid: true }), 6000);
        } else if (response.status.code == "N") {
          this.setState({
            showAlertModal: true,
            alertModalMsg: this.alertMsg.getListFailureMsg,
          });
        }
      });
  }

  fileChange = (e) => {
    this.onChange(e.target.files);
    this.setState(
      {
        showUploadGrid: false,
        step1State: STEP_STATE.active,
        isUploadBtnDisable: false,
        isUploadBtnLoading: false,
        step1Toggle: true,
        step2State: STEP_STATE.disabled,
        isValidateBtnDisable: false,
        isValidateBtnLoading: false,
        step2Toggle: true,
        step3State: STEP_STATE.disabled,
        isSubmitBtnLoading: false,
        step3Toggle: true,
      },
      () => {
        this.fileUpload();
      }
    );
  };

  onAddModifyRadio = () => {
    if (this.state.step1State === STEP_STATE.completed) return;
    this.setState({ isUpdateRadioActive: true });
  };

  onDeleteRadio = () => {
    if (this.state.step1State === STEP_STATE.completed) return;
    this.setState({ isUpdateRadioActive: false });
  };

  onStep2Confirm = () => {
    this.setState({
      showUploadGrid: false,
      step2Toggle: false,
      step2State: STEP_STATE.completed,
      step3State: STEP_STATE.active,
    });
  };

  handleDownload = () => {
    let merchantIdGlobal = this.merchantID;
    const formData = new FormData();
    formData.append("schoolId", merchantIdGlobal);

    let data = new URLSearchParams();
    data.append("schoolId", merchantIdGlobal);

    let authCode = localStorage.getItem("bearer");
    const url = this.state.isUpdateRadioActive
      ? API_URL.DOWNLOAD_ERR_FILE
      : API_URL.DOWNLOAD_DELETE_ERR_FILE;
    fetch(url, {
      method: "POST",
      body: data,
      headers: {
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = this.state.processValidationFileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
      });
  };

  resetStep2 = () => {
    this.resetStates();
    window.location.reload();
  }

  renderAlertModal() {
    return (
      <CustomModal
        show={this.state.showAlertModal}
        title={this.state.alertModalMsg}
        message={this.state.progressCompleteText}
        onHide={this.onHideAlertModal}
      />
    );
  }

  renderCommitListModal() {
    return (
      <Modal
        className="popUpModal"
        show={this.state.commitList}
        onHide={this.commitListClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>{STUDENT_DATA_CONSTANTS.INFORMATION}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{STUDENT_DATA_CONSTANTS.ERROR_ALREADY_EXISTS}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#6c757d" }}
            onClick={this.commitListClose}
          >
            {STUDENT_DATA_CONSTANTS.CANCEL}
          </Button>
          <Button onClick={this.commitListOk}>Ok</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderStep1() {
    const isCompleted = this.state.step1State === STEP_STATE.completed;
    const headerClass = isCompleted ? "student-upload-step" : "";
    return (
      <div className="mt-3">
        <button
          className={headerClass}
          style={{ border: "none", background: "transparent", width: "100%" }}
          onClick={
            isCompleted
              ? () => this.setState({ step1Toggle: !this.state.step1Toggle })
              : null
          }
        >
          <div className="d-flex flex-row align-items-center pt-3 pb-2">
            <BulletTag tag="A" isCheck={isCompleted} />
            <Typography variant="subtitle2" sx={{ textAlign: TEXT_ALIGN_LEFT }}>
              {STUDENT_DATA_CONSTANTS.UPLOAD_TEMPLATE}
            </Typography>
          </div>
          {isCompleted &&
            (this.state.step1Toggle ? <UpArrowLogo /> : <DownArrowLogo />)}
        </button>

        {this.state.step1Toggle && (
          <div className="d-flex flex-column w-100" style={{ marginLeft: 48 }}>
            <Typography
              variant="subtitle2"
              sx={{ textAlign: TEXT_ALIGN_LEFT, color: colors.grayLight }}
            >
              {STUDENT_DATA_CONSTANTS.SELECT_UPLOAD_TYPE}
            </Typography>

            <div className="d-flex flex-row align-items-center mt-2 mb-2 gap-4">
              <CustomRadioButton
                label="Add/Modify"
                disabled={
                  this.state.isSalesAdmin ||
                  this.state.step1State === STEP_STATE.completed
                }
                isChecked={this.state.isUpdateRadioActive}
                onClick={this.onAddModifyRadio}
              />

              <CustomRadioButton
                disabled={
                  this.state.isSalesAdmin ||
                  this.state.step1State === STEP_STATE.completed
                }
                label="Delete"
                isChecked={!this.state.isUpdateRadioActive}
                onClick={this.onDeleteRadio}
              />
            </div>

            <Form.Group className="upload-templete-box">
              <SideBarAddLogo bgColor={colors.primary} />
              <div className="w-100">
                <Typography
                  variant="body1"
                  className="mb-2"
                  sx={{ color: colors.primary }}
                >
                  {STUDENT_DATA_CONSTANTS.UPLOAD_TEMPLATE_FILE}
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ color: colors.grayLight, textAlign: TEXT_ALIGN_LEFT }}
                >
                  {STUDENT_DATA_CONSTANTS.TEMPLATE_MODES}
                </Typography>
              </div>
              <Form.Control
                id="custom-file"
                type="file"
                accept=".xls,.xlsx"
                onChange={this.fileChange}
                disabled={
                  this.state.isSalesAdmin || this.state.isSubmitBtnLoading
                }
                className="custom-file-input"
              />
            </Form.Group>
            <div style={{ width: 260, height: 18 }}></div>
            {this.state.step1State === STEP_STATE.completed && (
              <UploadSuccessMsg msg="Uploaded Successfully" />
            )}
          </div>
        )}
      </div>
    );
  }

  renderStep2() {
    const isCompleted = this.state.step2State === STEP_STATE.completed;
    const headerClass = isCompleted ? "student-upload-step" : "";
    return (
      <div>
        <button
          className={headerClass}
          style={{ border: "none", background: "transparent", width: "100%" }}
          onClick={
            isCompleted
              ? () => this.setState({ step2Toggle: !this.state.step2Toggle })
              : null
          }
        >
          <div className="d-flex flex-row align-items-center pt-3 pb-2">
            <BulletTag tag="B" isCheck={isCompleted} />
            <Typography variant="subtitle2" sx={{ textAlign: TEXT_ALIGN_LEFT }}>
              {STUDENT_DATA_CONSTANTS.VALIDATE_TEMPLATE}
            </Typography>
          </div>
          {isCompleted &&
            (this.state.step2Toggle ? <UpArrowLogo /> : <DownArrowLogo />)}
        </button>

        {this.state.step2Toggle && (
          <div
            className="d-flex flex-column mt-2"
            style={{ marginLeft: 48, width: "95%" }}
          >
            {this.state.step2State !== STEP_STATE.disabled &&
              !(this.state.uploadFailure1 || this.state.nullErrorMsg) && (
                <div className="my-3">
                  <PrimaryButton
                    label="Validate"
                    onClick={this.validateFile}
                    disabled={
                      this.state.step2State === STEP_STATE.completed ||
                      this.state.isValidateBtnDisable ||
                      this.state.uploadFailure1
                    }
                    isLoading={this.state.isValidateBtnLoading}
                  />
                </div>
              )}
            {this.state.isValidateBtnLoading && (
              <ProgressBar
                now={this.state.validateProgressPercent}
                label={`${this.state.validateProgressPercent}% : Validating document`}
              />
            )}
            {this.state.showUploadGrid && (
              <UploadAGgrid
                details={this.state.uploadDataList}
                isUpdateActive={this.state.isUpdateRadioActive}
              />
            )}
            {this.state.showUploadGrid && (
              <div className="my-3">
                <PrimaryButton label="Continue" onClick={this.onStep2Confirm} />
              </div>
            )}
            {this.state.uploadFailure1 && (
              <Fragment>
                <UploadErrorMsg msg={STUDENT_DATA_CONSTANTS.ERROR_IN_RECORDS} />
                <div className="d-flex w-100 justify-content-start my-4 gap-2">
                  <div className="flex-2">
                    <PrimaryButton
                      label="Back to loading the template"
                      onClick={this.resetStep2}
                    />
                  </div>

                  <Button
                    bsPrefix="download-failure-file flex-1"
                    onClick={this.handleDownload}
                  >
                    Download
                  </Button>
                </div>
              </Fragment>
            )}
            {this.state.showNullError ? (
              <div className="my-4">
                <UploadErrorMsg msg={this.state.nullErrorMsg} />
                <PrimaryButton
                  label="Back to loading the template"
                  onClick={this.resetStep2}
                />
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }

  renderStep3() {
    const isCompleted = this.state.step3State === STEP_STATE.completed;
    const headerClass = isCompleted ? "student-upload-step" : "";
    return (
      <div>
        <button
          className={headerClass}
          style={{ border: "none", background: "transparent", width: "100%" }}
          onClick={
            isCompleted
              ? () => this.setState({ step3Toggle: !this.state.step3Toggle })
              : null
          }
        >
          <div className="d-flex flex-row align-items-center pt-3 pb-2">
            <BulletTag tag="C" isCheck={isCompleted} />
            <Typography variant="subtitle2" sx={{ textAlign: TEXT_ALIGN_LEFT }}>
              {STUDENT_DATA_CONSTANTS.SUBMIT_DATA}
            </Typography>
          </div>
          {isCompleted &&
            (this.state.step3Toggle ? <UpArrowLogo /> : <DownArrowLogo />)}
        </button>

        {this.state.step3Toggle && (
          <div
            className="d-flex flex-column mt-2"
            style={{ marginLeft: 48, width: "95%" }}
          >
            {this.state.step3State !== STEP_STATE.disabled && (
              <div className="my-3">
                <PrimaryButton
                  label="Submit"
                  onClick={this.handleUploadCommit}
                  disabled={this.state.step3State === STEP_STATE.completed}
                  isLoading={this.state.isSubmitBtnLoading}
                />
              </div>
            )}
            {this.state.isSubmitBtnLoading && (
              <Typography
                variant="h6"
                className="mb-3"
                sx={{ color: "#868ca1", marginTop: 10 }}
              >
                {STUDENT_DATA_CONSTANTS.DATA_IN_PROGESS}
              </Typography>
            )}
            {this.state.step3State === STEP_STATE.completed && (
              <UploadSuccessMsg msg={this.state.progressCompleteText} />
            )}
          </div>
        )}
      </div>
    );
  }

  renderUploadContainer() {
    return (
      <div>
        <Typography variant="subtitle2" component="span">
          {STUDENT_DATA_CONSTANTS.UPLOAD_STUDENT_RECORDS}
        </Typography>
        {this.state.showIsProgressMsg && (
          <UploadErrorMsg msg={STUDENT_DATA_CONSTANTS.ANOTHER_UPLOAD_MSG} />
        )}
        {this.renderStep1()}
        <Row className="upload-template-divider" />
        {this.renderStep2()}
        <Row className="upload-template-divider" />
        {this.renderStep3()}
        <Row style={{ marginTop: 30 }} />
      </div>
    );
  }

  renderUpdateModuleContainer() {
    return (
      <div className="pb-4">
        <Typography variant="h5" component="div">
          {STUDENT_DATA_CONSTANTS.UPLOAD_STUDENT_DATA}
        </Typography>
        <DownloadTemplate />
        {this.renderUploadContainer()}
      </div>
    );
  }

  render() {
    return (
      <div className="d-flex flex-row w-100">
        <div className="d-flex flex-column p-4 gap-3" style={{ width: "65%" }}>
          {this.renderUpdateModuleContainer()}
          {this.renderAlertModal()}
          {this.renderCommitListModal()}
        </div>
        <ActivityStatus
          newLogin={this.state.newLogin}
          isNewLoginDelete={this.state.isNewLoginDelete}
          currentStatus={this.state.currentStatus}
          abortAction={this.abortAction}
        />
      </div>
    );
  }
}

export default StudentUpload;
